import type { IInputSelectModelValueType, IInputSelectPropsWithoutModelValue } from '@/components';
import { DropdownItemBase } from './DropdownItemBase';
import { reactive, type Ref } from 'vue';

type IDropdownItemSelect = {
    [K in keyof Omit<IInputSelectPropsWithoutModelValue, 'val'>]: undefined extends IInputSelectPropsWithoutModelValue[K]
        ? IInputSelectPropsWithoutModelValue[K] | Ref<Exclude<IInputSelectPropsWithoutModelValue[K], undefined>> | undefined
        : IInputSelectPropsWithoutModelValue[K] | Ref<Exclude<IInputSelectPropsWithoutModelValue[K], undefined>>;
};

export class DropdownItemSelect extends DropdownItemBase {
    modelValue: Ref<IInputSelectModelValueType>;
    props: IInputSelectPropsWithoutModelValue;

    get uniqueLoopKey() {
        // The loopkey here is kinda tricky.
        // We use the label and the class (which in most cases will be undefined)
        // Then the first 3 values in the datasource.
        // This will fail spectacularly if we have an async or function datasource, and no label
        // If you run into this problem, you can put a unique class on the dropdownitem

        const dspart =
            typeof this.props.datasource === 'function'
                ? ''
                : this.props.datasource?.source
                      ?.slice(0, 3)
                      .map((s) => `${s.text}-${s.value}`)
                      .join('-');

        return `${this.props.label}-${this.props.class}-${dspart}`;
    }

    /**
     * This is here so a pojo wont fit the class, and thus we get build errors if we havent used the create method
     */
    private abuseBlocker: boolean = false;

    private constructor(
        modelValue: Ref<IInputSelectModelValueType>,
        props: IDropdownItemSelect,
        hideDropDownItem?: Ref<boolean> | undefined,
    ) {
        super();
        this.modelValue = modelValue;
        this.hideDropDownItem = hideDropDownItem;

        this.props = reactive(props) as IInputSelectPropsWithoutModelValue; // as needed here because of the generic row
    }

    public static create(
        options: { modelValue: Ref<IInputSelectModelValueType> } & IDropdownItemSelect & Pick<DropdownItemBase, 'hideDropDownItem'>,
    ): DropdownItemSelect {
        const { modelValue, hideDropDownItem, ...props } = options;
        return new DropdownItemSelect(modelValue, props, hideDropDownItem);
    }
}
